import { render, staticRenderFns } from "./AccommodationCharges.vue?vue&type=template&id=0d321004&scoped=true"
import script from "./AccommodationCharges.vue?vue&type=script&lang=js"
export * from "./AccommodationCharges.vue?vue&type=script&lang=js"
import style0 from "./AccommodationCharges.vue?vue&type=style&index=0&id=0d321004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d321004",
  null
  
)

export default component.exports